module.exports = __webpack_public_path__ + "static/media/drop-down-up.73864fad.svg";